import { Box, Typography, useTheme, Button } from '@mui/material';
import { Children, cloneElement, isValidElement } from 'react';

import type { ChangeEvent, CSSProperties, FC, FormEvent, ReactElement, ReactNode } from 'react';

type FormWrapperProps = {
	formName: string;
	children: ReactNode;
	onSubmit: (event: FormEvent<HTMLFormElement>) => void;
	isFormPending: boolean;
	submitButton: {
		label: string;
		isDisabled: boolean;
		style?: CSSProperties;
	};
	formFooter?: ReactNode;
	style?: CSSProperties;
};

type ChildElement = ReactElement<{
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	value?: string;
	error?: boolean;
	helperText?: string;
	name?: string;
}>;

const FormWrapper: FC<FormWrapperProps> = ({
	formName,
	children,
	onSubmit,
	isFormPending,
	submitButton,
	formFooter,
	style = {},
}) => {
	const theme = useTheme();

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSubmit(event);
	};

	return (
		<Box
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				width: '348px',
				margin: '0',
				padding: '20px 20px 34px',
				border: '1px solid #ccc',
				backgroundColor: '#fff',
				...style,
			}}
		>
			<Typography
				variant="h1"
				style={{
					margin: '0',
					marginBottom: '0.35em',
					display: 'block',
					backgroundColor: 'white',
					inset: '0',
					padding: 0,
					zIndex: '10',
					fontStyle: 'normal',
					fontWeight: 500,
					fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
					lineHeight: '30px',
					color: 'hsla(0, 0%, 0%, 1)',
					alignSelf: 'flex-start',
				}}
			>
				{formName}
			</Typography>
			<form onSubmit={handleSubmit} style={{ boxSizing: 'border-box', width: '100%' }}>
				{Children.map(children as ChildElement | ChildElement[], (child: ChildElement) => {
					if (isValidElement(child) && child.props.name) {
						return cloneElement(child);
					}
					return child;
				})}
				{submitButton?.label ? (
					<Button
						disabled={submitButton.isDisabled}
						loading={isFormPending}
						variant="contained"
						color="primary"
						type="submit"
						fullWidth
						style={{
							marginTop: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '22px' : '37px',
							...(submitButton.style && submitButton.style),
						}}
					>
						{submitButton.label}
					</Button>
				) : null}
			</form>
			{formFooter ?? null}
		</Box>
	);
};

export default FormWrapper;
